import { render, staticRenderFns } from "./widgetBody.vue?vue&type=template&id=e4a3b4d6&scoped=true"
import script from "./widgetBody.vue?vue&type=script&setup=true&lang=js"
export * from "./widgetBody.vue?vue&type=script&setup=true&lang=js"
import style0 from "./widgetBody.vue?vue&type=style&index=0&id=e4a3b4d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a3b4d6",
  null
  
)

export default component.exports